import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/display.actions';
import * as home from '../../../../actions/process.home.actions';

import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Hidden from '@material-ui/core/Hidden';
import RegisterIcon from '@material-ui/icons/Highlight';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';
import Menu from '../Menu';

import { BlueTickIcon, TrashIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function toolbar(handleSummit, ok, handleDelete, id, handleRegister) {
    const deleteButton = id ? (
        <TrashIcon
            key="delete-post-display"
            className="hand"
            color="secondary"
            onClick={handleDelete}
        />
    ) : null;

    const registerButton = id ? (
        <RegisterIcon
            key="register-post-display"
            className="hand"
            color="primary"
            onClick={handleRegister}
        />
    ) : null;

    return [
        <BlueTickIcon
            disabled={!ok}
            key="submmit-post-display"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />,
        registerButton,
        deleteButton,
    ];
}

class Display extends React.Component {
    state = {
        id: randomstring(),
        tipo: 'PHILIPS_HUE',
        IDUNICO: '',
        LOGIN: '',
        PASSWORD: '',
        idLocal: undefined,
        plazo: '',
        tag: '',
        clase: '',
        brillo: '',
        error: '',
    };

    constructor(props) {
        super(props);
        if (props.id && props.id !== 'callback') {
            props.loadInfo(props.id);
        } else {
            console.log(props.id);
        }
    }

    componentDidUpdate() {
        const tools = toolbar(
            this.handleSummit,
            this.isCorrect(),
            this.handleDelete,
            this.props.id,
            this.handleRegister,
        );
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.display && nextProps.id) {
            const {
                id,
                tipo,
                IDUNICO,
                LOGIN,
                PASSWORD,
                idLocal,
                plazo,
                tag,
                clase,
                BRILLO,
            } = nextProps.display;
            this.setState({
                id: id,
                tipo: tipo ? tipo : 'PHILIPS_HUE',
                IDUNICO: IDUNICO ? IDUNICO : '',
                LOGIN: LOGIN ? LOGIN : '',
                PASSWORD: PASSWORD ? PASSWORD : '',
                idLocal: idLocal ? idLocal : '',
                plazo: plazo ? plazo : '',
                tag: tag ? tag : '',
                clase: clase ? clase : '',
                brillo: BRILLO ? BRILLO : '',
            });
        }
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked, edit: true });
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    isCorrect = () => {
        const { IDUNICO, LOGIN, PASSWORD } = this.state;
        return IDUNICO && LOGIN && PASSWORD;
    };

    handleDelete = () => {
        const { intl } = this.props;
        const r = window.confirm(intl.formatMessage({ id: 'delete_message_confirm' }));
        if (r === true) {
            this.props
                .deleteDisplay(this.props.id)
                .then((r) => {
                    this.props.history.push('/manage/displays');
                })
                .catch((error) => {
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    handleRegister = (event) => {
        this.props
            .getURLRegister(this.props.id)
            .then((r) => {
                try {
                    window.location.href = r.url;
                } catch (error) {
                    this.setState({
                        error: this.props.intl.formatMessage({ id: 'popup_blocked' }),
                    });
                }
            })
            .catch((error) => {
                this.setState({ error: error.message });
            });
    };

    handleSummit = () => {
        const {
            id,
            tipo,
            IDUNICO,
            LOGIN,
            PASSWORD,
            idLocal,
            plazo,
            tag,
            clase,
            brillo,
        } = this.state;
        const display = {
            tipo: tipo,
            IDUNICO: IDUNICO,
            LOGIN: LOGIN,
            PASSWORD: PASSWORD,
            idLocal: idLocal,
            plazo: plazo,
            tag: tag,
            clase: clase,
            BRILLO: brillo,
        };
        if (!this.props.id) {
            this.props
                .addDisplay(display)
                .then((r) => {
                    this.props.history.push('/manage/displays');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        } else {
            display.id = id;
            this.props
                .editDisplay(display)
                .then((r) => {
                    this.props.history.push('/manage/displays');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    Field = (field, name, intl, autoFocus = false, disable = false) => (
        <TextField
            autoFocus={autoFocus}
            fullWidth
            disabled={disable}
            id={name}
            name={name}
            required
            label={intl.formatMessage({ id: 'form_field_name_' + name })}
            className={'flex_full_row'}
            value={field}
            onChange={this.handleChange}
            margin="normal"
        />
    );

    render() {
        const {
            tipo,
            IDUNICO,
            LOGIN,
            PASSWORD,
            idLocal,
            plazo,
            tag,
            clase,
            brillo,
            error,
            errorType
        } = this.state;

        const { intl, id, displays_is_loading, displays_has_errored, info } = this.props;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20') &&
              info.security.licencias.some((f) => f.id === 156 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && displays_has_errored.hasErrored) {
            return (
                <Error open type={displays_has_errored.hasErrored}  message={displays_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            const nodes = info.security.locals;
            const classes = info.security.classes;
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {error && (
                        <Snackbar
                            open={true}
                            variant={ errorType ? errorType : "error" }
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    {displays_is_loading && <Loading open opacity />}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={5} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div className={'flex_full_column padding_bottom_9 height100 bg_white'}>
                            <div
                                className="flex_full overflow_y_scroll "
                                onScroll={this.handleScroll}
                            >
                                <div className="flex_full_column margin_top_18 padding_borders">
                                    {this.Field(tipo, 'tipo', intl, false, true)}
                                    {this.Field(IDUNICO, 'IDUNICO', intl, true)}
                                    {this.Field(LOGIN, 'LOGIN', intl)}
                                    {this.Field(PASSWORD, 'PASSWORD', intl)}
                                    <div className="flex_full_row margin_top_18 align_center">
                                        <FormControl
                                            className={'flex_full width100 barlow_italic c_slate'}
                                        >
                                            <InputLabel htmlFor="idLocal" shrink>
                                                {intl.formatMessage({ id: 'type_label_local' })}
                                            </InputLabel>
                                            <Select
                                                native
                                                name={'idLocal'}
                                                id={'idLocal'}
                                                value={idLocal}
                                                onChange={this.handleChange}
                                                inputProps={{ name: 'idLocal', id: 'idLocal' }}
                                            >
                                                <option key={randomstring()} value={undefined} />
                                                {nodes &&
                                                    nodes.map((cat) => {
                                                        return (
                                                            <option
                                                                key={randomstring()}
                                                                value={cat.id}
                                                            >
                                                                {cat.name}
                                                            </option>
                                                        );
                                                    })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="flex_full_row margin_top_18 align_center">
                                        <FormControl
                                            className={'flex_full width100 barlow_italic c_slate'}
                                        >
                                            <InputLabel htmlFor="clase" shrink>
                                                {intl.formatMessage({ id: 'type_label_class' })}
                                            </InputLabel>
                                            <Select
                                                name={'clase'}
                                                id={'clase'}
                                                native
                                                value={clase}
                                                onChange={this.handleChange}
                                                inputProps={{ name: 'clase', id: 'clase' }}
                                            >
                                                <option key={randomstring()} value={undefined} />
                                                {classes &&
                                                    classes.map((cat) => {
                                                        return (
                                                            <option
                                                                key={randomstring()}
                                                                value={cat.codigo}
                                                            >
                                                                {cat.nombre}
                                                            </option>
                                                        );
                                                    })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="flex_full_row margin_top_18 align_center">
                                        <TextField
                                            id="plazo"
                                            name="plazo"
                                            label={intl.formatMessage({
                                                id: 'form_field_name_plazo',
                                            })}
                                            value={plazo}
                                            onChange={this.handleChange}
                                            className={'flex_full_row'}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="flex_full_row margin_top_18 align_center">
                                        <TextField
                                            id="brillo"
                                            name="brillo"
                                            label={intl.formatMessage({
                                                id: 'form_field_name_brillo',
                                            })}
                                            value={brillo}
                                            onChange={this.handleChange}
                                            className={'flex_full_row'}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="flex_full_row margin_top_18 align_center">
                                        <TextField
                                            id="tag"
                                            name="tag"
                                            label={intl.formatMessage({
                                                id: 'form_field_name_tag',
                                            })}
                                            value={tag}
                                            onChange={this.handleChange}
                                            className={'flex_full_row'}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Display.propTypes = {
    intl: intlShape.isRequired,
    display: PropTypes.object.isRequired,
    info: PropTypes.object.isRequired,
    displays_has_errored: PropTypes.object.isRequired,
    displays_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        displays_has_errored: state.displays_has_errored,
        displays_is_loading: state.displays_is_loading,
        display: state.display,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

Display = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Display);

Display = withRouter(Display);
Display = injectIntl(Display);

export default Display;



// WEBPACK FOOTER //
// ./src/components/complex/manage/display/Index.js